import React from 'react'

export const Logo = ({logo, width, padding, alt="Logo", otherStyles}) => {
  return <img src={logo} alt={alt} style={{padding: padding, maxWidth: width, width: '100%', ...otherStyles}}/>;
}
